// A call ringing now (BL-099, QA-726): the one rule Calls' "Ringing now" and the office shell's
// ringing banner both read, and how the banner says who it is.
import { phoneText, type Call } from '../types.ts';

/**
 * The live events about calls: one ringing, answered, ended or changed. A live transcript's new lines
 * are call_transcript.lines_added, deliberately not call.*: only the call's own page reads them
 * (live-transcript-model.ts TRANSCRIPT_EVENTS).
 */
export const CALL_EVENTS = /^call\./;

/**
 * A call ringing in: the call open after it. An open call is never replaced, so nobody on a call is
 * thrown off it or loses what they typed (QA-771): the new one rings in the strip (Open the call) or,
 * without one, the banner and the count. With no call open it pops, as before.
 */
export function openAfterRing(open: string | null, rang: string): string {
  return open ?? rang;
}

/** A call whose end never came stops counting as ringing after a quarter hour (the recent list's then). */
export const RING_FRESH_MS = 15 * 60_000;

/** Still ringing, with nothing said on it yet, from the last quarter hour. */
export function stillRinging(c: Pick<Call, 'status' | 'outcome' | 'startedAt'>, now = Date.now()): boolean {
  return c.status === 'ringing' && !c.outcome && now - Date.parse(c.startedAt) < RING_FRESH_MS;
}

/** Who is calling, as the pop would name them: "Marco Bell, Lindqvist residence", "2 customers", "Unknown caller". */
export function ringingWho(c: Pick<Call, 'matches'>): string {
  if (c.matches.length > 1) return `One of ${c.matches.length} customers`;
  const m = c.matches[0];
  if (!m) return 'Unknown caller';
  return m.contactName && m.contactName !== m.customerName
    ? `${m.contactName}, ${m.customerName}`
    : m.customerName;
}

/** The banner's line: "Ringing now: Marco Bell, Lindqvist residence, (604) 555-0123." */
export function ringingWords(c: Pick<Call, 'matches' | 'from'>): string {
  return `Ringing now: ${ringingWho(c)}, ${phoneText(c.from)}.`;
}
